import { ChangeDetectorRef, Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { ParcellaStragiudiziale } from '../../../models/parcella-stragiudiziale';
import { SezioneParcelleStragiudiziali } from '../../../models/sezioni/sezione-parcelle-stragiudiziali';
import { AvvisoParcellaEditComponent } from './avviso-parcella-edit.component';
import { ParcelleStragiudizialiEditComponent } from './parcelle-stragiudiziali-edit.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [parcella-stragiudiziale-mod-edit]',
  templateUrl: 'parcella-stragiudiziale-mod-edit.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class ParcellaStragiudizialeModEdit {
  @Output() onReturn: EventEmitter<SezioneParcelleStragiudiziali> = new EventEmitter<SezioneParcelleStragiudiziali>();
  @ViewChild('formParcellaStragiudizialeEdit') formParcellaStragiudiziale: ParcelleStragiudizialiEditComponent;
  @ViewChild('formAvvisoParcella') formParcellaStragiudizialeFs: AvvisoParcellaEditComponent;
  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();
  isParcella: boolean = false;

  constructor(private changeDetectorRef: ChangeDetectorRef){

  }

  inizializza(sezione: SezioneParcelleStragiudiziali,
              parcellaStragiudiziale: ParcellaStragiudiziale,
              idSezioneLegali: string,
              idSezioneEconomica: string,
              urlUpdate: string,
              urlReadSezioneLegali: string,
              urlReadSezioneEconomica: string,
              urlGetScaglioni: string,
              tipoFascicolo: any,
              tipoPratica: number, idFascicolo: string) {
    /*if(this.isPrd){
      this.formParcellaStragiudiziale.inizializza(sezione,
                                            parcellaStragiudiziale,
                                            idSezioneLegali,
                                            idSezioneEconomica,
                                            urlUpdate,
                                            urlReadSezioneLegali,
                                            urlReadSezioneEconomica,
                                            urlGetScaglioni,
                                            tipoFascicolo,
                                            tipoPratica);
      } else*/
      this.changeDetectorRef.detectChanges(); //serve per checkare la view e i children (utile nel caso ci siano componenti con *ngIf che possono cambiare)
      if (this.isPrd){
        if(this.isParcella){
          this.formParcellaStragiudiziale.inizializza(sezione,
            parcellaStragiudiziale,
            idSezioneLegali,
            idSezioneEconomica,
            urlUpdate,
            urlReadSezioneLegali,
            urlReadSezioneEconomica,
            urlGetScaglioni,
            tipoFascicolo,
            tipoPratica, idFascicolo);
        }else {
          this.formParcellaStragiudizialeFs.inizializza(sezione,
            parcellaStragiudiziale,
            idSezioneLegali,
            idSezioneEconomica,
            urlUpdate,
            urlReadSezioneLegali,
            urlReadSezioneEconomica,
            urlGetScaglioni,
            tipoFascicolo,
            tipoPratica);
        }
        openModal('modalmodParcellaStragiudiziale');
      }

  }

  createForm() {
    /*if(this.isPrd) this.formParcellaStragiudiziale.createForm();
    else*/
    if (this.isPrd && !this.isParcella) this.formParcellaStragiudizialeFs.createForm();
    else this.formParcellaStragiudiziale.createForm();
  }

  manageModal(sezioneParcelleStragiudiziali: SezioneParcelleStragiudiziali) {
      closeModal('modalmodParcellaStragiudiziale');
      this.onReturn.emit(sezioneParcelleStragiudiziali);
  }
}
